<template>
    <Modal v-model="addTruckDialog" :mask-closable="false" width="550" draggable>
        <div slot="header"><strong>{{editMode?'Edit':'New'}} Truck</strong></div>
        <div>
            <Form :model="truckForm" :rules="ruleTruckForm" ref="truckForm" :label-width="110">
        <!--        <FormItem prop="name" label="Name">
                    <Input v-model="truckForm.name"/>
                </FormItem>                                         -->
                <FormItem prop="transporterName" label="Transporter">
                    <AutoComplete v-model="truckForm.transporterName" v-if="addTruckDialog">
                        <Option v-for="(transporter,index) in transporterArr" :label="transporter.name"
                                :key="index" :value="transporter.name">
                            <div class="ivu-select-item-div" @click="truckForm.transporterId=transporter.id">
                                {{transporter.name}}</div>
                        </Option>
                    </AutoComplete>
                </FormItem>

                <FormItem prop="plateNumber" label="Plate Number">
                    <Input v-model="truckForm.plateNumber"/>
                </FormItem>

                <FormItem prop="capacity" label="Capacity">
                    <Input v-model="truckForm.capacity" type="number"/>
                </FormItem>


                <FormItem prop="kmLimit" label="KM Limit">
                    <Input v-model="truckForm.kmLimit" type="number"/>
                </FormItem>

                <FormItem prop="routes" label="Routes">
                    <template v-for="(i, index) in numOfRoutes">
                        <AutoComplete v-model="routes_fromCity[index]" v-if="addTruckDialog" style="width: 45%;margin:0 10px 5px 0"
                                      @on-search="handleCitySearch" @on-focus="cityFilter='%%'" placement="top">
                            <Option v-for="(cityObj,index) in cityArr" :label="cityObj.city"
                                    :key="index" :value="cityObj.city">
                                <div class="ivu-select-item-div">{{cityObj.city}}</div>
                            </Option>
                        </AutoComplete>
                        <AutoComplete v-model="routes_toCity[index]" v-if="addTruckDialog" style="width: 45%;margin:0 5px 5px 0"
                                      @on-search="handleCitySearch" @on-focus="cityFilter='%%'" placement="top">
                            <Option v-for="(cityObj,index) in cityArr" :label="cityObj.city"
                                    :key="index" :value="cityObj.city">
                                <div class="ivu-select-item-div">{{cityObj.city}}</div>
                            </Option>
                        </AutoComplete>
                        <Icon type="md-add-circle" size="22" v-if="index==0" @click="numOfRoutes++"/>
                    </template>
                </FormItem>
            </Form>
        </div>
        <div slot="footer">
            <Button v-if="!editMode" type="primary" style="font-weight: bolder" @click="addTruck" :loading="loading">
                <span v-if="!loading">SAVE</span>
                <span v-else>Loading...</span>
            </Button>
            <Button v-if="editMode" type="primary" style="font-weight: bolder" @click="modifyTruck" :loading="loading">
                <span v-if="!loading">UPDATE</span><span v-else>Loading...</span>
            </Button>
            <Button style="background: #999999; color: white;font-weight: bolder" @click="addTruckDialog=false">CANCEL</Button>
        </div>
    </Modal>
</template>

<script>
import {ADD_TRUCK, UPDATE_TRUCK} from '../../graphql/mutations/vehicle'
import { SEARCH_CITY2} from '../../graphql/queries/territories'
import { SEARCH_TRANSPORTER} from '../../graphql/queries/companies'
import {generateUUID} from '../../Constants/Constant'
import ValidationRules from '../../Constants/ValidationRules'
import _ from 'lodash'
    export default {
        apollo: {
            city: {
                query: SEARCH_CITY2,
                variables() {
                    return {
                        cityFilter: this.cityFilter
                    }
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.cityArr = data.city;
                    }
                }
            },
            company: {
                query: SEARCH_TRANSPORTER,
                fetchPolicy: "network-only",
                variables() {
                    return {
                        transporterFilter: this.transporterFilter,
                    }
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.transporterArr = data.company;
                    }
                }
            },
        },
        name: "AddTruck",
        data: function(){
            return{
                mutation_ADD_TRUCK: ADD_TRUCK,
                mutation_UPDATE_TRUCK: UPDATE_TRUCK,
                cityArr: [],
                transporterArr: [],
                truckForm:{
                    id: '',
                    name: '',
                    plateNumber: '',
                    capacity: '',
                    kmLimit: '',
                    transporterName: '',
                    transporterId :'',
                    routes: []
                },
                ruleTruckForm:{
                    // name: ValidationRules.textField('Name'),
                    plateNumber: ValidationRules.textField('Plate Number'),
                    city: [{}],
                    capacity: ValidationRules.numberField,
                    kmLimit: ValidationRules.numberField,
                    transporterName: ValidationRules.textField('Transporter'),
                },
                addTruckDialog: false,
                editMode: false,
                numOfRoutes: 1,
                routes_fromCity: {},
                routes_toCity: {},
                cityFilter: '%%',
                loading: false
            }
        },
        computed: {
            transporterFilter(){
                return '%' + this.truckForm.transporterName + '%'
            }
        },
        methods: {
            reset: function(){
                this.$refs['truckForm'].resetFields();
            },
            handleCitySearch: _.debounce(function(val){
                this.cityFilter = '%' + val + '%'
            }, 500),
            onAddTruck(transporterData){
                this.reset();
                this.numOfRoutes = 1;
                this.routes_fromCity = {};
                this.routes_toCity = {};
                this.editMode = false;
                this.$apollo.queries.company.refetch();   //forcefully refetch query to get added Transporter
                this.addTruckDialog = true;
                /* ------Autofill Transporter data if any ------- */
                if(transporterData){
                  this.truckForm.transporterId = transporterData.id;
                  this.truckForm.transporterName = transporterData.name;
                }
                /* -------------x-------------x------------------ */
            },
            addTruck(){
                this.loading = true;
                this.$refs['truckForm'].validate((valid) => {
                    if (valid) {
                        this.insertTruck();
                    }else{
                        this.loading = false
                    }
                })
            },
            async insertTruck(){
                /* ------------- routes array ------------ */
                for(var i=0; i<this.numOfRoutes; i++){
                    this.truckForm.routes.push({fromCity: this.routes_fromCity[i], toCity: this.routes_toCity[i]})
                }
                /* ---------- x----------x-----------x----- */
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_ADD_TRUCK,
                    variables: {
                        id: generateUUID(),
                        name: this.truckForm.name,
                        platNo: this.truckForm.plateNumber,
                        capacity: this.truckForm.capacity,
                        kmLimit: this.truckForm.kmLimit,
                        transporterId: this.truckForm.transporterId,
                        routes: this.truckForm.routes
                    }
                })
                if(response.data.insert_truck.returning[0].id){
                    this.$Message.success('New Truck added successfully!');
                    this.reset();
                    this.loading = false;
                    this.addTruckDialog = false;
                }
            },
            onEditTruck(truckData){
                this.reset();
                this.routes_fromCity = {};
                this.routes_toCity = {};
                this.numOfRoutes = truckData.routes.length;
                this.truckForm.id = truckData.id;
                this.truckForm.name = truckData.name;
                this.truckForm.plateNumber = truckData.platNo;
                this.truckForm.capacity = truckData.capacity;
                this.truckForm.kmLimit = truckData.kmLimit;
                this.truckForm.transporterId = truckData.company.id;
                this.truckForm.transporterName = truckData.company.name;
                for(var i=0; i<truckData.routes.length; i++){
                    this.routes_fromCity[i] = truckData.routes[i].fromCity
                    this.routes_toCity[i] = truckData.routes[i].toCity
                }
                this.editMode = true;
                this.addTruckDialog = true;
            },
            modifyTruck(){
                this.loading = true;
                this.$refs['truckForm'].validate((valid) => {
                    if (valid) {
                        this.updateTruck();
                    }
                })
            },
            async updateTruck(){
                /* ------------- routes array ------------ */
                for(var i=0; i<this.numOfRoutes; i++){
                    this.truckForm.routes.push({fromCity: this.routes_fromCity[i], toCity: this.routes_toCity[i]})
                }
                /* ---------- x----------x-----------x----- */
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_UPDATE_TRUCK,
                    variables: {
                        truckId: this.truckForm.id,
                        name: this.truckForm.name,
                        platNo: this.truckForm.plateNumber,
                        capacity: this.truckForm.capacity,
                        kmLimit: this.truckForm.kmLimit,
                        transporterId: this.truckForm.transporterId,
                        routes: this.truckForm.routes
                    }
                })
                if(response.data){
                    this.$Message.success('Truck updated successfully!');
                    this.reset();
                    this.loading = false;
                    this.addTruckDialog = false;
                }
            },
        }
    }
</script>

<style scoped>
    /deep/ .ivu-modal-close{
        visibility: hidden;
    }
    /deep/ .code-uppercase > input{
        text-transform: uppercase;
    }
    /deep/ .ivu-modal-body{
        max-height: 500px !important;
        overflow-y: auto !important;
    }
    /deep/ .ivu-auto-complete.ivu-select-dropdown{
      max-height: 200px !important;
    }
</style>
